module.exports = __webpack_public_path__ + "img/GALLERY-IGNIS-2021-2.cdf6698e.jpg";